/**
 * 積雪深グラフ生成
 */
import color from "../../scss/color.scss";
import libCG, { str } from "./CommonGraph";

export default {
  name: "lib-snow-graph",
  getSvgGraph,
  getSvgLeftLabel,
  getSvgRightLabel,
  getSvgLegend,
  getImageGraph,
};

// グラフ描画領域上余白
const paddingTop = 40;
// グラフ描画領域下余白
const paddingBottom = 120;
// ラベル描画領域左余白
const paddingLeft = 50;
// ラベル描画領域右余白
const paddingRight = 50;
// ラベル分割数
const divY = 8;
// ラベル表示間隔
const spaceY = 2;
// ラベル桁数（小数点以下）
const labelDisit = 0;

// 凡例サイズ
const legendWidth = 640;
const legendHeight = 775;
const legendPadding = 10;

// 見出し文字サイズ
const baseTitleSize = 72;
const baseTitleWeight = 500;

// グラフのスタイル
const styleGraph = `<![CDATA[
  .kwg-snow-normal {
    fill: ${color.snowNormal};
    stroke: ${color.snowNormal};
    stroke-width: 1;
    opacity: 0.8;
  }
  .kwg-snow-level1 {
    fill: ${color.snowLevel1};
    stroke: ${color.snowlevel1};
    stroke-width: 1;
    opacity: 0.8;
  }
  .kwg-snow-level2 {
    fill: ${color.snowLevel2};
    stroke: ${color.snowLevel2};
    stroke-width: 1;
    opacity: 0.8;
  }
  .kwg-snow-level3 {
    fill: ${color.snowLevel3};
    stroke: ${color.snowLevel3};
    stroke-width: 1;
    opacity: 0.8;
  }
  .kwg-snow-level4 {
    fill: ${color.snowLevel4};
    stroke: ${color.snowlevel4};
    stroke-width: 1;
    opacity: 0.8;
  }
  .kwg-snow-level5 {
    fill: ${color.snowLevel5};
    stroke: ${color.snowLevel5};
    stroke-width: 1;
    opacity: 0.8;
  }
  .kwg-snow-level6 {
    fill: ${color.snowLevel6};
    stroke: ${color.snowLevel6};
    stroke-width: 1;
    opacity: 0.8;
  }
  .kwg-temp-normal {
    fill: ${color.snowTemp};
    stroke: ${color.snowTemp};
    stroke-width: 15;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
]]>`;
// 左ラベルのスタイル
const styleLeftLabel = `<![CDATA[
  .kwg-snow-label {
  fill: ${color.snowNormalText};
  font-weight: bold;
  font-size: 48px;
  font-family: sans-serif;
  }
  .kwg-snow-label-title {
    fill: ${color.snowNormalText};
    font-weight: TITLEWEIGHT;
    font-size: TITLESIZE;
    font-family: sans-serif;
  }
]]>`;
// 右ラベルのスタイル
const styleRightLabel = `<![CDATA[
  .kwg-temp-label {
  fill: ${color.snowTempText};
  font-weight: bold;
  font-size: 48px;
  font-family: sans-serif;
  }
  .kwg-temp-label-title {
    fill: ${color.snowTempText};
    font-weight: TITLEWEIGHT;
    font-size: TITLESIZE;
    font-family: sans-serif;
  }
]]>`;
// 凡例のスタイル
const styleLegend = `<![CDATA[
  .kwg-legend-rect {
    fill: white;
    stroke: dodgerblue;
    stroke-width: 9;
    opacity: 0.9;
  }
  .kwg-legend-line {
    stroke: dodgerblue;
    stroke-width: 9;
    opacity: 0.9;
  }
  .kwg-legend-label {
    fill: black;
    font-weight: 500;
    font-size: 54px;
  }
  .kwg-legend-label-unit {
    fill: black;
    font-weight: 500;
    font-size: 36px;
  }
]]>`;

/**
 * SVGグラフ取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      snwdp: 積雪深
 *      tmp: 気温
 *    spec: 観測所情報
 *      snow: 積雪深
 *        max: 積雪深最大値
 *        lvl6: 積雪深基準値6
 *        lvl5: 積雪深基準値5
 *        lvl4: 積雪深基準値4
 *        lvl3: 積雪深基準値3
 *        lvl2: 積雪深基準値2
 *        lvl1: 積雪深基準値1
 *        min: 積雪深最小値
 *        title: 積雪深ラベル
 *        unit: 積雪深単位
 *      tmp: 気温
 *        max: 気温最大値
 *        min: 気温最小値
 *        title: 気温ラベル
 *        unit: 気温単位
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 * @return SVGグラフ
 */
function getSvgGraph(obsInfo, viewProp) {
  // svgタグ生成
  let svgGraph = libCG.makeGraphSvgTag(
    viewProp.width,
    viewProp.height,
    viewProp.isExp
  );
  // gタグ追加
  addGGraph(svgGraph, obsInfo, viewProp, false, 0);

  return svgGraph.outerHTML;
}

/**
 * グラフグループ追加
 * @param {*} parent 親要素
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 * @param {*} isSvg 画像提供モード
 * @param {*} offsetY 余白の高さ
 */
function addGGraph(parent, obsInfo, viewProp, isSvg, offsetY) {
  // 積雪深グラフ表示範囲
  let x = 0;
  let y = paddingTop;
  let w = libCG.computeGraphWidth(isSvg ? false : viewProp.isExp);
  let h =
    libCG.computeHeight(viewProp.width, viewProp.height) -
    paddingTop -
    paddingBottom -
    offsetY;
  // gタグ追加
  let g = libCG.addGraphGroupTag(parent);
  // styleタグ追加
  libCG.addStyleTag(g, styleGraph);
  // 積雪深フレーム追加
  libCG.addGraphFrameTag(
    g,
    x,
    y,
    w,
    h,
    obsInfo.value,
    viewProp.isExp,
    true,
    divY
  );
  // 積雪深時刻ラベル追加
  libCG.addGraphXAxisLabelTag(
    g,
    x,
    y + h,
    w,
    obsInfo.value,
    viewProp.isExp,
    true
  );
  // ツールチップ追加
  addGraphTooltip(g, x, y, w, h, obsInfo, viewProp);
  // 積雪深棒グラフ追加
  addGraphSnow(g, x, y, w, h, obsInfo, viewProp);
  // 気温線グラフ追加
  addGraphTemp(g, x, y, w, h, obsInfo, viewProp);

  return g;
}

/**
 * ツールチップタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addGraphTooltip(parent, left, top, width, height, obsInfo, viewProp) {
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    true,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    true,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let w = xs - 2;
  let tag;
  let data;

  for (let index = 0; index < obsInfo.value.length; index++) {
    data = obsInfo.value[index];
    x = x - xs;
    if (data != null) {
      tag = libCG.makeToolTipSvgTag(
        x + 1,
        top,
        w,
        height,
        "kwg-tip",
        makeTip(obsInfo, data, true, true)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 積雪深棒グラフタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addGraphSnow(parent, left, top, width, height, obsInfo, viewProp) {
  let max = obsInfo.spec.snow.max;
  let min = obsInfo.spec.snow.min;
  let lvl6 = obsInfo.spec.snow.lvl6;
  let lvl5 = obsInfo.spec.snow.lvl5;
  let lvl4 = obsInfo.spec.snow.lvl4;
  let lvl3 = obsInfo.spec.snow.lvl3;
  let lvl2 = obsInfo.spec.snow.lvl2;
  let lvl1 = obsInfo.spec.snow.lvl1;

  let bottom = top + height;
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    true,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    true,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let w = xs - 2;
  let ys = height / (max - min);
  let y, h, t;
  let tag, tip;
  let data;

  for (let index = 0; index < obsInfo.value.length; index++) {
    data = obsInfo.value[index];
    x = x - xs;
    t = max;
    if (
      data == null ||
      data.snwdp == null ||
      data.snwdp > max ||
      data.snwdp <= min
    ) {
      continue;
    }
    tip = makeTip(obsInfo, data, true, true);
    if (lvl6 != null && data.snwdp > lvl6) {
      y = bottom - ys * (data.snwdp - min);
      t = Math.max(lvl6, min);
      h = bottom - ys * (t - min) - y - 1;
      tag = libCG.makeBarGraphSvgTag(
        x - w / 2 + 1, // 中央表示のため幅の半分だけ左にずらす
        y,
        w,
        h,
        "kwg-snow-level6",
        tip
      );
      parent.appendChild(tag);
    }
    if (lvl5 != null && t > min && data.snwdp > lvl5) {
      y = bottom - ys * Math.min(data.snwdp - min, t - min);
      t = Math.max(lvl5, min);
      h = bottom - ys * (t - min) - y - 1;
      tag = libCG.makeBarGraphSvgTag(
        x - w / 2 + 1, // 中央表示のため幅の半分だけ左にずらす
        y,
        w,
        h,
        "kwg-snow-level5",
        tip
      );
      parent.appendChild(tag);
    }
    if (lvl4 != null && t > min && data.snwdp > lvl4) {
      y = bottom - ys * Math.min(data.snwdp - min, t - min);
      t = Math.max(lvl4, min);
      h = bottom - ys * (t - min) - y - 1;
      tag = libCG.makeBarGraphSvgTag(
        x - w / 2 + 1, // 中央表示のため幅の半分だけ左にずらす
        y,
        w,
        h,
        "kwg-snow-level4",
        tip
      );
      parent.appendChild(tag);
    }
    if (lvl3 != null && t > min && data.snwdp > lvl3) {
      y = bottom - ys * Math.min(data.snwdp - min, t - min);
      t = Math.max(lvl3, min);
      h = bottom - ys * (t - min) - y - 1;
      tag = libCG.makeBarGraphSvgTag(
        x - w / 2 + 1, // 中央表示のため幅の半分だけ左にずらす
        y,
        w,
        h,
        "kwg-snow-level3",
        tip
      );
      parent.appendChild(tag);
    }
    if (lvl2 != null && t > min && data.snwdp > lvl2) {
      y = bottom - ys * Math.min(data.snwdp - min, t - min);
      t = Math.max(lvl2, min);
      h = bottom - ys * (t - min) - y - 1;
      tag = libCG.makeBarGraphSvgTag(
        x - w / 2 + 1, // 中央表示のため幅の半分だけ左にずらす
        y,
        w,
        h,
        "kwg-snow-level2",
        tip
      );
      parent.appendChild(tag);
    }
    if (lvl1 != null && t > min && data.snwdp > lvl1) {
      y = bottom - ys * Math.min(data.snwdp - min, t - min);
      t = Math.max(lvl1, min);
      h = bottom - ys * (t - min) - y - 1;
      tag = libCG.makeBarGraphSvgTag(
        x - w / 2 + 1, // 中央表示のため幅の半分だけ左にずらす
        y,
        w,
        h,
        "kwg-snow-level1",
        tip
      );
      parent.appendChild(tag);
    }
    if (t > min) {
      y = bottom - ys * Math.min(data.snwdp - min, t - min);
      h = bottom - y - 1;
      tag = libCG.makeBarGraphSvgTag(
        x - w / 2 + 1, // 中央表示のため幅の半分だけ左にずらす
        y,
        w,
        h,
        "kwg-snow-normal",
        tip
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * 気温線グラフタグ追加
 * @param {*} parent 親要素
 * @param {*} left グラフ描画領域左端
 * @param {*} top グラフ描画領域上端
 * @param {*} width グラフ描画領域幅
 * @param {*} height グラフ描画領域高さ
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 */
function addGraphTemp(parent, left, top, width, height, obsInfo, viewProp) {
  let cls = "kwg-temp-normal";
  let max = obsInfo.spec.tmp.max;
  let min = obsInfo.spec.tmp.min;

  let bottom = top + height;
  let before = libCG.computeTimeLineBeforeOffset(
    viewProp.isExp,
    true,
    obsInfo.value[0].time
  );
  let after = libCG.computeTimeLineAfterOffset(
    viewProp.isExp,
    true,
    obsInfo.value[obsInfo.value.length - 1].time
  );
  let xs = width / (obsInfo.value.length + before + after);
  let x = left + width - xs * before;
  let ys = height / (max - min);
  let x1, x2, y1, y2;
  let tag;
  let prev = null;
  let current, next;

  for (let index = 0; index < obsInfo.value.length - 1; index++) {
    current = obsInfo.value[index];
    next = obsInfo.value[index + 1];
    x = x - xs;

    if (
      current == null ||
      current.tmp == null ||
      current.tmp > max ||
      current.tmp < min
    ) {
      prev = null;
      continue;
    }

    if (next == null || next.tmp == null || next.tmp > max || next.tmp < min) {
      next = null;
    }

    x1 = x - 1;
    y1 = bottom - ys * (current.tmp - min);

    if (next != null) {
      x2 = x - xs + 1;
      y2 = bottom - ys * (next.tmp - min);
      tag = libCG.makeLineGraphSvgTag(
        x1,
        y1,
        x2,
        y2,
        cls,
        makeTip(obsInfo, next, false, true)
      );
      parent.appendChild(tag);
    }

    if (viewProp.isExp) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        null,
        cls,
        makeTip(obsInfo, current, false, true)
      );
      parent.appendChild(tag);
    } else if (prev == null && next == null) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        4,
        cls,
        makeTip(obsInfo, current, false, true)
      );
      parent.appendChild(tag);
    }

    prev = current;
  }

  current = obsInfo.value[obsInfo.value.length - 1];
  if (
    current != null &&
    current.tmp != null &&
    current.tmp <= max &&
    current.tmp >= min
  ) {
    x1 = x - xs - 1;
    y1 = bottom - ys * (current.tmp - min);

    if (viewProp.isExp) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        null,
        cls,
        makeTip(obsInfo, current, false, true)
      );
      parent.appendChild(tag);
    } else if (prev == null) {
      tag = libCG.makeCircleSvgTag(
        x1,
        y1,
        4,
        cls,
        makeTip(obsInfo, current, false, true)
      );
      parent.appendChild(tag);
    }
  }
}

/**
 * ツールチップ情報生成
 * @param {*} obsInfo 観測所情報
 * @param {*} data 観測値
 * @param {*} isSnow 積雪深情報（true=表示, false=非表示）
 * @param {*} isTemp 気温情報（true=表示, false=非表示）
 */
function makeTip(obsInfo, data, isSnow, isTemp) {
  let tip = data.date + " " + data.time;
  if (isSnow) {
    tip = tip + str.CRLF + obsInfo.spec.snow.title + str.Sept;
    if (data.snwdp != null) {
      tip = tip + data.snwdp + obsInfo.spec.snow.unit;
    } else {
      tip = tip + str.None;
    }
  }
  if (isTemp) {
    tip = tip + str.CRLF + obsInfo.spec.tmp.title + str.Sept;
    if (data.tmp != null) {
      tip = tip + data.tmp + obsInfo.spec.tmp.unit;
    } else {
      tip = tip + str.None;
    }
  }
  return tip;
}

/********** **********/

/**
 * SVG左軸取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      snwdp: 積雪深
 *      tmp: 気温
 *    spec: 観測所情報
 *      snow: 積雪深
 *        max: 積雪深最大値
 *        lvl6: 積雪深基準値6
 *        lvl5: 積雪深基準値5
 *        lvl4: 積雪深基準値4
 *        lvl3: 積雪深基準値3
 *        lvl2: 積雪深基準値2
 *        lvl1: 積雪深基準値1
 *        min: 積雪深最小値
 *        title: 積雪深ラベル
 *        unit: 積雪深単位
 *      tmp: 気温
 *        max: 気温最大値
 *        min: 気温最小値
 *        title: 気温ラベル
 *        unit: 気温単位
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 * @return SVG左ラベル
 */
function getSvgLeftLabel(obsInfo, viewProp) {
  // svgタグ生成
  let svgLeftLabel = libCG.makeLabelSvgTag(viewProp.width, viewProp.height);
  // gタグ追加
  addGLeftLabel(svgLeftLabel, obsInfo, viewProp, 0);

  return svgLeftLabel.outerHTML;
}

/**
 * 左ラベルグループ追加
 * @param {*} parent 親要素
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 * @param {*} offsetY 余白の高さ
 */
function addGLeftLabel(parent, obsInfo, viewProp, offsetY) {
  let spec = obsInfo.spec.snow;
  // 積雪深左ラベル表示範囲
  let x = paddingLeft;
  let y = paddingTop;
  let w = libCG.computeLabelWidth() - paddingLeft;
  let h =
    libCG.computeHeight(viewProp.width, viewProp.height) -
    paddingTop -
    paddingBottom -
    offsetY;
  // gタグ生成
  let g = libCG.addLeftLabelGroupTag(
    parent,
    viewProp.width,
    viewProp.height,
    obsInfo
  );
  // 文字サイズ算出
  const size = libCG.computeTitleSize(
    viewProp.width,
    viewProp.height,
    baseTitleSize,
    baseTitleWeight
  );
  let style = String(styleLeftLabel);
  style = style.replace(/TITLEWEIGHT/g, size.weight);
  style = style.replace(/TITLESIZE/g, size.size + "px");
  // styleタグ追加
  libCG.addStyleTag(g, style);
  // 積雪深目盛タグ追加
  libCG.addLeftLabelYAxisLabelTag(
    g,
    x,
    y,
    w,
    h,
    spec.max,
    spec.min,
    labelDisit,
    divY,
    spaceY,
    "kwg-snow-label"
  );
  // 積雪深ラベルタグ追加
  libCG.addLeftLabelYAxisTitleTag(
    g,
    x,
    y,
    w,
    h,
    spec.title,
    spec.unit,
    "kwg-snow-label-title"
  );

  return g;
}

/********** **********/

/**
 * SVG右軸取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      snwdp: 積雪深
 *      tmp: 気温
 *    spec: 観測所情報
 *      snow: 積雪深
 *        max: 積雪深最大値
 *        lvl6: 積雪深基準値6
 *        lvl5: 積雪深基準値5
 *        lvl4: 積雪深基準値4
 *        lvl3: 積雪深基準値3
 *        lvl2: 積雪深基準値2
 *        lvl1: 積雪深基準値1
 *        min: 積雪深最小値
 *        title: 積雪深ラベル
 *        unit: 積雪深単位
 *      tmp: 気温
 *        max: 気温最大値
 *        min: 気温最小値
 *        title: 気温ラベル
 *        unit: 気温単位
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 * @return SVG右ラベル
 */
function getSvgRightLabel(obsInfo, viewProp) {
  // svgタグ生成
  let svgRightLabel = libCG.makeLabelSvgTag(viewProp.width, viewProp.height);
  // gタグ追加
  addGRightLabel(svgRightLabel, obsInfo, viewProp, 0);

  return svgRightLabel.outerHTML;
}

/**
 * 右ラベルグループ追加
 * @param {*} parent 親要素
 * @param {*} obsInfo 観測所情報
 * @param {*} viewProp 描画プロパティ
 * @param {*} offsetY 余白の高さ
 */
function addGRightLabel(parent, obsInfo, viewProp, offsetY) {
  let spec = obsInfo.spec.tmp;
  // 気温右ラベル表示範囲
  let x = 0;
  let y = paddingTop;
  let w = libCG.computeLabelWidth() - paddingRight;
  let h =
    libCG.computeHeight(viewProp.width, viewProp.height) -
    paddingTop -
    paddingBottom -
    offsetY;
  // gタグ生成
  let g = libCG.addRightLabelGroupTag(
    parent,
    viewProp.width,
    viewProp.height,
    obsInfo
  );
  // 文字サイズ算出
  const size = libCG.computeTitleSize(
    viewProp.width,
    viewProp.height,
    baseTitleSize,
    baseTitleWeight
  );
  let style = String(styleRightLabel);
  style = style.replace(/TITLEWEIGHT/g, size.weight);
  style = style.replace(/TITLESIZE/g, size.size + "px");
  // styleタグ追加
  libCG.addStyleTag(g, style);
  // 累加積雪深目盛タグ追加
  libCG.addRightLabelYAxisLabelTag(
    g,
    x,
    y,
    w,
    h,
    spec.max,
    spec.min,
    labelDisit,
    divY,
    spaceY,
    "kwg-temp-label"
  );
  // 累加積雪深ラベルタグ追加
  libCG.addRightLabelYAxisTitleTag(
    g,
    x,
    y,
    w,
    h,
    spec.title,
    spec.unit,
    "kwg-temp-label-title"
  );

  return g;
}

/********** **********/

/**
 * SVG凡例取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      snwdp: 積雪深
 *      tmp: 気温
 *    spec: 観測所情報
 *      snow: 積雪深
 *        max: 積雪深最大値
 *        lvl6: 積雪深基準値6
 *        lvl5: 積雪深基準値5
 *        lvl4: 積雪深基準値4
 *        lvl3: 積雪深基準値3
 *        lvl2: 積雪深基準値2
 *        lvl1: 積雪深基準値1
 *        min: 積雪深最小値
 *        title: 積雪深ラベル
 *        unit: 積雪深単位
 *      tmp: 気温
 *        max: 気温最大値
 *        min: 気温最小値
 *        title: 気温ラベル
 *        unit: 気温単位
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 * @return SVG凡例
 */
function getSvgLegend(obsInfo, viewProp) {
  // svgタグ生成
  let svgLegend = libCG.makeLegendSvgTag(
    viewProp.width,
    viewProp.height,
    legendWidth + legendPadding,
    legendHeight + legendPadding
  );
  // gタグ追加
  addGLegend(svgLegend, obsInfo);

  return svgLegend.outerHTML;
}

/**
 * 凡例グループ追加
 * @param {*} parent 親要素
 * @param {*} obsInfo 観測所情報
 */
function addGLegend(parent, obsInfo) {
  let tag;
  let specSnow = obsInfo.spec.snow;
  let specTemp = obsInfo.spec.tmp;
  let w = legendWidth;
  let h = legendHeight;
  let x = 0;
  // eslint-disable-next-line
  let y;
  // gタグ追加
  let g = libCG.addLegendGroupTag(parent);
  // styleタグ追加
  libCG.addStyleTag(g, styleLegend);
  // 枠
  tag = libCG.makeLegendFrame(5, 5, w, h, "kwg-legend-rect");
  g.appendChild(tag);
  // 仕切線
  tag = libCG.makeLegendLine(5, 610, w, 610, "kwg-legend-line");
  g.appendChild(tag);
  // 積雪深凡例
  y = 75;
  y = libCG.addLegendTitle(
    g,
    x,
    y,
    specSnow.title,
    "kwg-legend-label",
    specSnow.unit,
    "kwg-legend-label-unit"
  );
  y = libCG.addLegendBarGraph(
    g,
    x,
    y,
    "kwg-snow-level6",
    specSnow.lvl6 + str.Over,
    "kwg-legend-label"
  );
  y = libCG.addLegendBarGraph(
    g,
    x,
    y,
    "kwg-snow-level5",
    specSnow.lvl5 + str.Interval + specSnow.lvl6 + str.Under,
    "kwg-legend-label"
  );
  y = libCG.addLegendBarGraph(
    g,
    x,
    y,
    "kwg-snow-level4",
    specSnow.lvl4 + str.Interval + specSnow.lvl5 + str.Under,
    "kwg-legend-label"
  );
  y = libCG.addLegendBarGraph(
    g,
    x,
    y,
    "kwg-snow-level3",
    specSnow.lvl3 + str.Interval + specSnow.lvl4 + str.Under,
    "kwg-legend-label"
  );
  y = libCG.addLegendBarGraph(
    g,
    x,
    y,
    "kwg-snow-level2",
    specSnow.lvl2 + str.Interval + specSnow.lvl3 + str.Under,
    "kwg-legend-label"
  );
  y = libCG.addLegendBarGraph(
    g,
    x,
    y,
    "kwg-snow-level1",
    specSnow.lvl1 + str.Interval + specSnow.lvl2 + str.Under,
    "kwg-legend-label"
  );
  libCG.addLegendBarGraph(
    g,
    x,
    y,
    "kwg-snow-normal",
    specSnow.lvl1 + str.Under,
    "kwg-legend-label"
  );
  // 気温凡例
  y = 680;
  y = libCG.addLegendTitle(
    g,
    x,
    y,
    specTemp.title,
    "kwg-legend-label",
    specTemp.unit,
    "kwg-legend-label-unit"
  );
  libCG.addLegendLineGraph(
    g,
    x,
    y,
    "kwg-temp-normal",
    specTemp.title,
    "kwg-legend-label"
  );

  return g;
}

/********** **********/

/**
 * 画像グラフ取得
 * @param obsInfo 観測所情報
 *    value[]: 観測値
 *      date: 観測日
 *      time: 観測時間
 *      snwdp: 積雪深
 *      tmp: 気温
 *    spec: 観測所情報
 *      obs: 観測所情報
 *        obsNm: 観測所名
 *        rsysNm: 水系名
 *        rvrNm: 河川名
 *        obsDt: 観測日時
 *      snow: 積雪深
 *        max: 積雪深最大値
 *        lvl6: 積雪深基準値6
 *        lvl5: 積雪深基準値5
 *        lvl4: 積雪深基準値4
 *        lvl3: 積雪深基準値3
 *        lvl2: 積雪深基準値2
 *        lvl1: 積雪深基準値1
 *        min: 積雪深最小値
 *        title: 積雪深ラベル
 *        unit: 積雪深単位
 *      tmp: 気温
 *        max: 気温最大値
 *        min: 気温最小値
 *        title: 気温ラベル
 *        unit: 気温単位
 * @param viewProp 描画プロパティ
 *    width: 親要素の幅
 *    height: 親要素の高さ
 *    isExp: 拡大/全体表示（true=拡大, false=全体）
 *    isInfo: 観測所情報表示（true=表示, false=非表示）
 *    isLegend: 凡例表示（true=表示, false=非表示）
 * @param callback 画像生成後に呼び出すコールバック関数
 * @return SVGオブジェクト
 */
function getImageGraph(obsInfo, viewProp, callback) {
  let g;
  let offsetX;
  let offsetY = 0;
  let lw = viewProp.isLegend ? legendWidth + legendPadding : 0;
  let graphProp = Object.assign({}, viewProp);
  graphProp.width = libCG.computeImageGraphWidth(viewProp.width, lw);

  // svgタグ生成
  let svgImage = libCG.makeImageSvgTag(viewProp.width, viewProp.height, lw);

  // 観測所情報追加
  if (viewProp.isInfo && obsInfo.spec.obs != null) {
    let obs = obsInfo.spec.obs;
    offsetY = libCG.addObsInfo(
      svgImage,
      obs.obsNm,
      obs.rsysNm,
      obs.rvrNm,
      obs.obsDt
    );
  }

  // 左ラベル追加
  g = addGLeftLabel(svgImage, obsInfo, graphProp, offsetY);
  g.setAttribute("transform", "translate(0," + offsetY + ")");

  // グラフ追加
  g = addGGraph(svgImage, obsInfo, graphProp, true, offsetY);
  offsetX = libCG.computeLabelWidth();
  g.setAttribute("transform", "translate(" + offsetX + "," + offsetY + ")");

  // 右ラベル追加
  g = addGRightLabel(svgImage, obsInfo, graphProp, offsetY);
  offsetX = libCG.computeLabelWidth() + libCG.computeGraphWidth(false);
  g.setAttribute("transform", "translate(" + offsetX + "," + offsetY + ")");

  // 凡例追加
  if (viewProp.isLegend) {
    g = addGLegend(svgImage, obsInfo);
    offsetX = libCG.computeLabelWidth() * 2 + libCG.computeGraphWidth(false);
    g.setAttribute(
      "transform",
      "translate(" + offsetX + "," + (offsetY + 50) + ")"
    );
  }
  // 画像要素返却
  if (callback != null) {
    callback(svgImage);
  }

  return svgImage;
}
